import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@app/state/app.state';
import { combineLatest, Subscription } from 'rxjs';
import { SetBillingType } from '@utility-information/state/actions/utility-information.actions';
import { billingTypeSelector, utilityConsolidatedBillingSelector, utilityDualBillingSelector } from '@utility-information/state/selectors/utility-information.selectors';
import { isReadOnlySelector } from '@app/state/app.selectors';


@Component({
  selector: 'app-billing-input',
  templateUrl: './billing.component.html'
})
export class BillingComponent implements OnInit, OnDestroy {

  @Input() quoteRequestId: any | null;
  isDisabled: boolean = false;
  value: string
  previousValue: string
  billing$: Subscription;
  isReadOnly: boolean;

  constructor(private store: Store<AppState>,) { }

  ngOnDestroy(): void {
    this.billing$.unsubscribe();
  }

  ngOnInit(): void {
    this.store.select(billingTypeSelector).subscribe(x => { this.value = x })
    this.setInputValue();
  }

  setInputValue() {

   this.billing$ = combineLatest([
      this.store.select(utilityConsolidatedBillingSelector),
      this.store.select(utilityDualBillingSelector),
      this.store.select(isReadOnlySelector)
    ]).subscribe(
      ([consolidated, dual, isReadOnly]) => {
        ////Commenting this out. This is going to be addressed post production (multiple utilities). AM-04/11/2024
        //// So its been decided that the default value will be Consolidated, allowing the user to change it if otherwise. AM-04/11/2024
        // this.setDisabled(consolidated, dual, isReadOnly);
        this.setDisabled(true, true, isReadOnly);
        if(!this.value) {
          ////Commenting this out. This is going to be addressed post production (multiple utilities). AM-04/11/2024
          //// So its been decided that the default value will be Consolidated, allowing the user to change it if otherwise. AM-04/11/2024
          // this.setDefault(consolidated, dual)
          this.setDefault(true, true);
        }
          
      
      }
    )
  }

  setDisabled(consolidated: boolean, dual: boolean, isReadOnly: boolean) {
    this.isDisabled = ((consolidated && !dual) || (!consolidated && dual) || (!consolidated && !dual)) || isReadOnly;
  }

  setDefault(consolidated: boolean, dual: boolean) {
        this.previousValue = this.value;
        if (consolidated && dual)
          this.value = BillingType.Consolidated
        else if (consolidated) {
          this.value = BillingType.Consolidated
        } else if (dual) {
          this.value = BillingType.Dual
    }
        if (this.previousValue != this.value)
          this.store.dispatch(new SetBillingType(null, this.value));
  }

  changeBillingType(event) {
    this.store.dispatch(new SetBillingType(null, event.value));
  }
}

enum BillingType {
  Dual = 'Dual',
  Consolidated = 'Consolidated',

}
